<template>
  <div class="section">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/services">Services</router-link>
      <router-link :to="`/services/100`"><Icon icon="computer" />Antrag auf Ausbildungsförderung</router-link>
      <router-link to="/services/100/section-3">Eigenes Einkommen & Vermögen</router-link>
    </Breadcrumb>
    <div class="section__header">
      <div class="headline-link wrapper">
        <div class="headline-link__headline">
          <router-link to="/services/100" class="back-button"><Icon icon="arrowLeft" /></router-link>
          <Icon icon="education" color="detailed" class="hide-mobile"/>
          <Headline subline="Abschnitt 3" headline="Eigenes Einkommen & Vermögen" />
        </div>
        <div class="headline-link__right hide-mobile">
          <div>
            <h3><b>01</b> / 03</h3>
            <div class="progress" title="Fortschritt">
              <div class="bar" style="width: 33%;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section__content wrapper margin-bottom--90 margin-top--40">
      <div class="row between-xs top-xs">
        <div class="section__content__left col-xs-12 col-md-8">

<!-- Angaben zum Einkommen -->
          <h3 class="margin-bottom--20 margin-top--60">1. Angaben zum Einkommen</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <div class="row">
              <div class="col-xs-12 label-hint">
                <h6>Bewilligungszeitraum (BWZ)</h6>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Hallo hallo</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Hallo hallo</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <InputText name="from" type="date">
                  Von
                </inputText>
              </div>
              <div class="col-xs-12 col-md-6">
                <InputText name="to" type="date">
                  Bis
                </inputText>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 label-hint margin-top--20">
                <h6>Werden Sie Einnahmen im Bewilligunszeitraum beziehen?</h6>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Hallo hallo</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Hallo hallo</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row radios">
              <div class="col-xs-12 col-md-2">
                <input type="radio" id="no" :value="false" v-model="bwz">
                <label for="no">Nein</label>
              </div>
              <div class="col-xs-12 col-md-4">
                <input type="radio" id="yes" :value="true" v-model="bwz">
                <label for="yes">Ja, und zwar folgende:</label>
              </div>
            </div>
            <transition name="showcase">
              <div v-show="bwz" class="hide">
                <div class="row">
                  <div class="col-xs-12 label-hint">
                    <h6>Einnahmen <span>(im gesamten BWZ)</span></h6>
                  </div>
                </div>

                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Waisenrente und/oder Waisengeld (einschließlich Weihnachtszuwendung</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Ausbildungs-und Praktikumsvergütung brutto - auch Sachbezüge</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Hallo hallo</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Hallo hallo</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Voraussichtliche Brutto-Einnahmen aus bestehenden oder ruhenden Arbeitsverhältnissen, Ferien-, Gelegenheits-, Mini-Jobs</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Sonstige Renten (z.B. Unfallrenten)</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Einkünfte aus selbstständiger Arbeit, Gewerbebetriebe, Vermietung und Verpachtung, Land- und Forstwirtschaft</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Einkünfte aus Kapitalvermögen (z.B. Sparzinsen)</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Unterhaltsleistungen meines dauernd von mir getrennt lebenden oder meines geschiedenen Ehegatten bzw. nicht mehr verbundenen eingetragenen Lebenspartners </p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Zuwendungen von Firmen oder privaten Stiftungen (z. B. Stipendien)</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Ausbildungsbeihilfen und gleichartige Leistungen aus öffentlichen Mitteln sowie Förderungsleistungen anderer Staaten, soweit sie zur Deckung des Lebensunterhalts oder der üblichen Ausbildungskosten bestimmt sind (z. B. Stipendien, AFBG)</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Sonstige Ausbildungsbeihilfen</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Einnahmen, die zur Deckung des Unterhaltsbedarfs meines Ehegatten/meines eingetragenen Lebenspartners bestimmt sind</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list">Einnahmen, die zur Deckung des Unterhaltsbedarfs meiner Kinder bestimmt sind</p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row middle-xs">
                  <div class="col-xs-12 col-md-8">
                    <p class="list"> Ich habe folgende noch nicht bewilligte Sozialleistungen beantragt (z. B. Waisenrente, AFBG) </p>
                  </div>
                  <div class="col-xs-10 col-md-2">
                    <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                      Von
                    </inputText>
                  </div>
                  <div class="file col-xs-2">
                    <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                      <Icon icon="fileAdd" />
                    </div>
                    <div class="hint">
                      <Icon icon="hint" />
                      <div class="hint__tooltip">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>

<!-- Angaben zum Vermögen -->
          <h3 class="margin-bottom--20 margin-top--60">2. Angaben zum Vermögen</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <div class="row">
              <div class="col-xs-12 label-hint">
                <h6>Angaben zu Ihrem Vermögen zum Zeitpunkt der Antragsstellung</h6>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Hallo hallo</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Hallo hallo</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Höhe des Barvermögens (Bargeld)</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Höhe des Bank- und Sparguthabens, einschließlich des Guthabens auf Girokonten</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Höhe des Bauspar- und Prämiensparguthabens</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Höhe des steuerlich geförderten Altersvorsorgevermögens ("Riesterrente")</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Kraftfahrzeug (Zeitwert)</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Lebensversicherungen (Rückkaufswert)</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Land- und forstwirtschaftliche Grundstücke (auch Mieteigentumsanteile; Zeitwert)</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Sonstige unbebaute Grundstücke (auch Mieteigentumsanteile; Zeitwert)</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Betriebsvermögen (auch Mieteigentumsanteile; Zeitwert)</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Wertpapiere (z.B. Aktien, Pfandbriefe, Schatzanweisungen, Wechsel, Schecks; Zeitwert)</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Forderungen und Sonstige Rechte</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Sonstige Vermögensgegenstände</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

<!-- Angaben zu Schulden -->
          <h3 class="margin-bottom--20 margin-top--60">3. Angaben zu Schulden & Lasten</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <div class="row">
              <div class="col-xs-12 label-hint">
                <h6>Angaben zu Ihren Schulden & Lasten zum Zeitpunkt der Antragsstellung</h6>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Hallo hallo</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Hallo hallo</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Hypotheken, Grundschulden und sonstige Belastungen auf einem der genannten Vermögenswerte</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Lasten, z. B. Verpflichtungen zu wiederkehrenden Leistungen, Beschränkungen des Eigentums zu Gunsten Dritter (Nießbrauch, Rentenverpflichtung)</p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row middle-xs">
              <div class="col-xs-12 col-md-8">
                <p class="list">Sonstige Schulden, auch Verbindlichkeiten aus Studienkrediten und dem Bildungskreditprogramm des Bundes, nicht jedoch Darlehen nach dem BAföG </p>
              </div>
              <div class="col-xs-10 col-md-2">
                <InputText name="hello" :top="false" type="number" placeholder="in €" errorMsg="Falscher Wert">
                  Von
                </inputText>
              </div>
              <div class="file col-xs-2">
                <div class="file-button" title="Nachweis beifügen" @click="toggleFileModal">
                  <Icon icon="fileAdd" />
                </div>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Erklärungen zum Einkommen können gegebenenfalls durch eine Kontenabfrage nach § 93 Abs. 8 AO beim Bundeszentralamt für Steuern überprüft werden.</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Um Ihre Bezüge ausrechnen zu können, benötigen wir die vollständigen Angaben Ihres Einkommens und Vermögens.</p>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
        
        <Modal v-if="showFileModal" @closeModal="toggleFileModal" :outside="true">
          <Card padding="35px" class="modal-new">
            <Headline subline="Nachweis beifügen" headline="Leider nicht möglich"/>
            <p>Ätsch! Diese Funktion steht in diesem Prototyp leider nicht zur Verfügung.</p>
          </Card>           
        </Modal>

        <!-- Sidebar -->
        <div class="section__content__sidebar col-xs-12 col-md-3">
          <div class="nav-element done"
            @click="activeField = 1"
            :class="{'selected' : activeField == 1}"
            >
            <p>1. Angaben zum Einkommen</p>
            <div class="status"></div>
          </div>
          <div class="nav-element"
            @click="activeField = 2"
            :class="{'selected' : activeField == 2}"
            >
            <p>2. Angaben zum Vermögen</p>
            <div class="status"></div>
          </div>
          <div class="nav-element"
            @click="activeField = 3"
            :class="{'selected' : activeField == 3}"
            >
            <p>3. Angaben zu Schulden & Lasten</p>
            <div class="status"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="teaser">
      <div class="wrapper">
        <div class="row between-xs">
          <div class="col-xs-12 col-md-8">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <router-link to="/services/100/section-2">
                  <Button type="secondary" text="Vorheriger Abschnitt"/>
                </router-link>
              </div>
              <div class="col-xs-12 col-md-6">
                <Button type="secondary" text="Eingaben prüfen"/>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <router-link to="/services/100/section-4">
              <Button type="primary" text="Weiter zu Abschnitt 4"/>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import InputText from '../../components/formElements/InputText/InputText';
import InputSelect from '../../components/formElements/InputSelect/InputSelect';
import InputAutocomplete from '../../components/formElements/InputAutocomplete/InputAutocomplete';


export default {
  name: 'Section1',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    Button,
    Modal,
    InputText,
    InputAutocomplete,
    InputSelect,
  },
  data() {
    return {
      showModal: false,
      showFileModal: false,
      showDocModal: false,
      activeField: 1,
      toggleAll: false,
      time: '',
      bwz: false,
      insurance: false,
      baby: false
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',

    }),
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleFileModal() {
      this.showFileModal = !this.showFileModal;
    },
    toggleDocModal() {
      this.showDocModal = !this.showDocModal;
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Section.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Section/Section3.vue